import { Component, Inject, ElementRef, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AppAttendanceService } from '../../../core/services/appAttendanceService.service';
import { AppAttendance, AppAttendanceSummary } from '../../../core/models/appAttendace.model';
import { MessageDialog } from '../../../components/message-dialog/messageDialog';
import { formatDate, formatDateToTime } from '../../helpers/getIsoStringDate.js'
import { ListFormBase } from '../../../core/helper/ListFormBase';
import { ActivatedRoute, Router } from '@angular/router';
import { EditMarcajesDialog } from '../../marcajes/edit-marcajes-dialog/edit-marcajes-dialog.component';
import { DOCUMENT } from '@angular/common';
import { MarcajeCoordinatesDialog } from '../marcaje-coordinates-dialog/marcaje-coordinates-dialog.component';
import { adjustTimeToSystemTimezone } from '../../helpers/getLocalDate.js';
import { MarcajeExportDialog } from '../marcaje-export-dialog/marcaje-export-dialog.component';

import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import XLSX from "xlsx-js-style"
import { SessionHelper } from '../../../core/helper/sessionHelper';


@Component({
  selector: 'app-edit-marcajes-summary-dialog',
  templateUrl: './edit-marcajes-summary-dialog.component.html',
  styleUrls: ['./edit-marcajes-summary-dialog.component.scss'],
  providers: [AppAttendanceService]
})



export class EditMarcajesSummaryDialog extends ListFormBase<AppAttendance> implements AfterViewInit {

  panelIcon = 'calendar-day'; // font awesome icon
  panelTitle = 'Editar día';
  panelDescription = '';
  appAttendanceModel: AppAttendance;
  appAttendanceSummaryModel: AppAttendanceSummary;
  @ViewChild('scrollableSection', { static: false }) scrollableSection: ElementRef;
  isNew: boolean = false;
  now: Date = new Date();
  valid: string;


  originalData: AppAttendance[] = [];
  dataSource: AppAttendance[] = [];
  @ViewChild('dataGrid') dataGrid: any;

  exporting = false;

  constructor(
    public dialogRef: MatDialogRef<EditMarcajesDialog>,
    @Inject(MAT_DIALOG_DATA) public inputData: any,
    public appAttendanceService: AppAttendanceService,
    protected _modelService: AppAttendanceService,
    protected _router: Router,
    protected _route: ActivatedRoute,
    protected _messageDialog: MessageDialog,
    protected _editMarcajesDialog: MatDialog,
    protected _exportMarcajesDialog: MatDialog,
    private cdr: ChangeDetectorRef,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private _session: SessionHelper

  ) {
    super(_modelService, _router, _route, _messageDialog, AppAttendance);

    if (inputData) {
      this.inputData.day = formatDate(this.inputData.day, false, true, false)
      this.panelTitle = `Editar día (${formatDate(this.inputData.day, false, true, true)}) (${this.inputData.userData.fullName})`;
      this.appAttendanceSummaryModel = inputData;
      this.valid = inputData.valid;
      this.isCrud = true;
    }

  }

  ngOnInit(): void {
  }


  ngAfterViewInit() {
    this.loadData();
  }

  closePopUp() {
    this.dialogRef.close();
  }

  formatExportNameDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}_${month}_${year}`;
  }


  /* PONGO EL BOTON A MANO PORQUE SI NO CIERRA EL COMPOENTE PADRE AL ABRIR EL HIJO */
  onToolbarPreparing1(e) {
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'exportpdf',
        onClick: () => this.exportToPDF(),
      },
    });

    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        elementAttr: {
          class: 'btn btn-primary btn-sm btn-add btn-add-new-custom',
          id: 'btn-add-new-custom'
        },
        icon: 'add',
        onClick: () => this.onClickAdd(),
        template: () => {
          return `<i class="material-icons">add</i><span class="d-none d-sm-inline-block" style="padding: 0.5em;">Nuevo</span>`;
        }
      }
    });

    setTimeout(() => {
      const buttonElement = document.getElementById('btn-add-new-custom');
      if (buttonElement) {
        buttonElement.classList.remove('dx-button', 'dx-button-mode-text', 'dx-button-normal', 'dx-button-has-icon', 'dx-state-focused');
      }
    }, 0);
  }


  onEditorPreparing(e): void {
    if (e.parentType === 'searchPanel') {
      e.editorOptions.stylingMode = 'underlined';
    }
  }

  validChange(value: string) {
    if ((value === 'true') !== (this.valid === 'Sí')) {
      this.valid = (value === 'true') ? 'Sí' : 'No';
    }
  }

  onRowPrepared(event: any) {
    if (event.rowType === 'data' && !event.data.valid) {
      event.rowElement.style.setProperty('background-color', '#ffdcdc', 'important');
      event.rowElement.style.setProperty('transition', 'background-color 0.2s ease', 'important');
      event.rowElement.classList.remove('dx-row-alt');
    }
  }

  async loadData(): Promise<void> {
    try {
      if (this.dataGrid?.instance) {
        this.dataGrid.instance.beginCustomLoading('');
      }

      this.dataSource = this.appAttendanceSummaryModel.records;


    } catch (error) {
      console.error('Error al cargar los datos:', error);
    } finally {
      if (this.dataGrid?.instance) {
        this.dataGrid.instance.endCustomLoading();
      }
    }
  }



  onClickToggleValid(data: any): void {
    this._messageDialog.showQuestionInput(
      `Se ${data.data.valid ? `marcará el registro como NO válido` : `marcará el registro como válido`}`,
      `${data.data.valid ? 'Marcar como NO válido' : 'Marcar como válido'}`,
      data.data.notes ? data.data.notes : '',
      "Nota"
    )
      .then(result => {
        if (result.isConfirmed) {  // Notas no obligatorias
          data.data.notes = result.value !== undefined ? result.value : '';  // Asignar cadena vacía si result.value es ''
          this.appAttendanceService.toggleValid({ id: data.data.attendanceRecord1, data: data.data }).subscribe(
            (response) => {
            },
            (error) => {
              console.error('Error al editar:', error);
            }
          );
          data.data.valid = !data.data.valid;
          this.cdr.detectChanges();
        }
      });
  }

  onClickDisable(data: any): void {
    this._messageDialog.ShowQuestion(

      `Se ${data.data.enabled ? `deshabilitará el registro, no será visible para el empleado ni será válido para el recuento de horas` : `habilitará  el registro, será visible para el empleado y será válido para el recuento de horas`}`,
      `${data.data.enabled ? 'Deshabilitar' : 'Habilitar'}`

    )
      .then(result => {
        if (result.value) {
          this.appAttendanceService.toggleEnabled({ id: data.data.attendanceRecord1, data: data.data }).subscribe(
            (response) => {
            },
            (error) => {
              console.error('Error al editar:', error);
            }
          );
          data.data.enabled = !data.data.enabled;
          this.cdr.detectChanges();
        }
      });
  }


  onClickAdd() {
    const childDialog = this._editMarcajesDialog.open(EditMarcajesDialog, {
      width: '100%',
      data: { defaultData: this.appAttendanceSummaryModel }
    });

    const dialogContainer = this.document.querySelectorAll('.mat-dialog-container')[1];
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
    }

    childDialog.afterClosed().subscribe(result => {
      if (result) {
        this.appAttendanceSummaryModel.records.push(result)
        this.dataSource = this.appAttendanceSummaryModel.records
      }
    });
  }


  onClickCheck(e) {
    const dialogRef = this._editMarcajesDialog.open(EditMarcajesDialog, {
      width: '100%',
      data: e,
    });

    const dialogContainer = this.document.querySelectorAll('.mat-dialog-container')[1];
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
    }

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  onLocationCheck(e) {

    const dialogRef = this._editMarcajesDialog.open(MarcajeCoordinatesDialog, {
      width: '100%',
      data: e,
    });

    const dialogContainer = this.document.querySelector('.mat-dialog-container');
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
    }

    dialogRef.afterClosed().subscribe(result => {
    });
  }


  onExporting(e) {
    e.cancel = true;

    const childDialog = this._exportMarcajesDialog.open(MarcajeExportDialog, {
      width: '50%'
    });

    const dialogContainer = this.document.querySelectorAll('.mat-dialog-container')[1];
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
    }

    childDialog.afterClosed().subscribe(result => {
      if (result) {
        const { disabled } = result;
        // Obtener la fuente de datos con los filtros actuales
        const dataSource = this.dataSource;
        // Ordenar los datos al revés
        const sortedRecords = dataSource.sort((a, b) => new Date(b.attendanceAt).getTime() - new Date(a.attendanceAt).getTime());

        // Filtrar y formatear los datos
        const filteredData = sortedRecords
          .filter(item => disabled || item.enabled) // Si disabled es true, muestra todos; si es false, solo los habilitados
          .map(item => ({
            Estado: item.valid ? 'Válido' : 'No válido',
            Día: formatDate(item.localAttendanceAt ?? item.attendanceAt, false, true, true),
            Empresa: item.companyData?.name || '',
            Empleado: item.userData?.fullName || '',
            'Hora Marcaje': item.attendanceAt ? formatDateToTime(item.localAttendanceAt ?? item.attendanceAt) : '',
            'Zona Horaria': item.timeZone ?? '',
            Tipo: item.typeData?.name || '',
            Origen: item.source == 'WEB' ? 'MANUAL' : item.source,
            Centro: item.workCenterData?.name || '',
            Localización: item.coordinates || 'Sin localización'
          }));


        // Exportar a Excel
        this.exportToExcel(filteredData, this.generateExportFileName());

      }
    });
  }



  onSubmit(): void {
    /* this.appAttendanceSummaryModel.valid = this.valid;
    this.appAttendanceSummaryModel.day = formatDate(this.appAttendanceSummaryModel.day, false, true);

    // Comprobar si hay salidas y obtener la última
    const exitRecords = this.appAttendanceSummaryModel.records.filter(record => record.typeData.name === 'Salida oficina');
    if (exitRecords.length > 0) {
      const lastExit = exitRecords.reduce((prev, curr) => new Date(prev.createdAt) > new Date(curr.createdAt) ? prev : curr);
      this.appAttendanceSummaryModel.lastExit = lastExit;

      // Calcular total de horas en formato HH:mm
      const firstEntryTime = new Date(this.appAttendanceSummaryModel.firstEntryTime).getTime();
      const lastExitTime = new Date(lastExitTime).getTime();
      const totalMinutes = Math.floor((lastExitTime - firstEntryTime) / (1000 * 60));
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      // Formatear en HH:mm
      this.appAttendanceSummaryModel.totalHours = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    }

    this.dialogRef.close(this.appAttendanceSummaryModel); */
  }

  showYesOrNo = (data: any): string => {
    return data.valid ? 'Sí' : 'No';
  };

  adjustAttendanceTime(rowData: any) {
    const adjustedDate = formatDate(rowData.localAttendanceAt ?? adjustTimeToSystemTimezone(rowData.attendanceAt).iso, true, true, true);
    return adjustedDate;
  }

  formatCoordinates(rowData: any) {
    return rowData.coordinates ? rowData.coordinates : 'Sin localización';
  }

  generateExportFileName(): string {
    return `Listado_Registros_(${formatDate(this.inputData.day, false, true, true)})(${this.inputData.userData.fullName})`;
  }

  getStatusColor(valid: boolean): string {
    return valid ? '#4caf50' : '#f44336'; // Verde para válido, rojo para no válido
  }

  getIconForStatus(valid: boolean): [string, string] {
    return valid ? ['fas', 'check'] : ['fas', 'times'];
  }

  getIconForSource(source: string): [string, string] {
    return source === 'APP' ? ['fas', 'mobile-alt'] : ['fas', 'hand-paper'];
  }

  formatSource(data: any): string {
    return data.source === 'WEB' ? 'MANUAL' : data.source;
  }

  exportToPDF(): void {

    const childDialog = this._exportMarcajesDialog.open(MarcajeExportDialog, {
      width: '50%'
    });

    const dialogContainer = this.document.querySelectorAll('.mat-dialog-container')[1];
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
    }

    childDialog.afterClosed().subscribe(result => {
      if (result) {
        const { disabled } = result;

        const doc = new jsPDF({ orientation: 'landscape' });
        const now = new Date();
        const localTime = formatDate(now.toISOString(), true, true, true);
        const utcTime = formatDate(now.toISOString(), true, true, true, true) + ' (UTC)';
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const creationDateDisplay = `${localTime} (${timeZone}) - ${utcTime}`; // Fecha y hora
        let pageCount = 0; // Contador de páginas

        const combinedFilter = this.dataGrid.instance.getCombinedFilter();
        const filteredDataSource = this.dataGrid.instance.getDataSource().store()
          .load({ filter: combinedFilter })
          .then((filteredData) => {

            // Ordenar los datos de más nuevo a más viejo
            const sortedData = [...filteredData].filter(item => disabled || item.enabled).sort((a, b) => new Date(b.day).getTime() - new Date(a.day).getTime());

            // Obtener el usuario desde el session
            const userName = `${this._session.User.Name || 'Usuario'} ${this._session.User.Surname || ''}`.trim();

            // Agregar el texto en el pie de página
            const addFooter = () => {
              const pageHeight = doc.internal.pageSize.height;
              const pageWidth = doc.internal.pageSize.width;
              pageCount++;
              doc.setFontSize(8); // Tamaño pequeño para el pie de página
              doc.text(`Generado por ${userName} el: ${creationDateDisplay}`, 10, pageHeight - 10); // Fecha y hora 
              doc.text(`Página ${pageCount}`, pageWidth - 50, pageHeight - 10); // Número de página
            };


            // Ruta y tamaño de la imagen
            const imgPath = 'assets/img/livesHR-good-color.png';
            const imgWidth = 20; // Imagen más pequeña
            const imgHeight = 10;
            const imgX = doc.internal.pageSize.width - imgWidth - 5; // Más pegada a la esquina derecha
            const imgY = 3; // Más cerca del borde superior

            // Cargar la imagen como base64
            const imagePromise = fetch(imgPath)
              .then(res => res.blob())
              .then(blob => {
                const reader = new FileReader();
                return new Promise<string>((resolve) => {
                  reader.onloadend = () => resolve(reader.result as string);
                  reader.readAsDataURL(blob);
                });
              });

            imagePromise.then((imgBase64) => {
              // Función para añadir la imagen en todas las páginas
              const addHeaderImage = () => {
                doc.addImage(imgBase64, 'PNG', imgX, imgY, imgWidth, imgHeight);
              };

              // Añadir la imagen en la primera página
              addHeaderImage();

              // Título principal
              doc.setFontSize(12); // Tamaño reducido del título principal
              doc.text('Reporte Detallado de Asistencia', 10, 20);

              const tableData = sortedData.map(item => [
                item.valid ? 'Válido' : 'No válido', // Validez
                item.localAttendanceAt ? formatDate(item.localAttendanceAt, true, true, true) + ` (${item.timeZone})` : formatDate(item.attendanceAt, true, true, true) ?? '---', //Fecha de registro
                item.companyData?.name || '---', // Empresa
                item.userData?.fullName || '---', // Empleado
                item.typeData?.name || '---', // Tipo (entrada/salida)
                item.workCenterData?.name || '---', // Centro de trabajo
                item.source === 'WEB' ? 'MANUAL' : item.source || '---', // Origen
                item.workCenterData?.coordinates || 'Sin coordenadas', // Coordenadas
                item.enabled ? 'Habilitado' : 'Deshabilitado', // Habilitado
              ]);

              autoTable(doc, {
                head: [['Estado', 'Fecha registro', 'Empresa', 'Empleado', 'Tipo', 'Centro de Trabajo', 'Origen', 'Coordenadas', 'Habilitado']],
                body: tableData,
                startY: 30, // Ajustar para que no se sobreponga con la imagen
                styles: { fontSize: 10 }, // Tamaño de texto más pequeño en la tabla
                didDrawPage: () => {
                  addHeaderImage(); // Añadir la imagen en todas las páginas
                  addFooter(); // Añadir pie de página
                },
              });
              // Guarda el PDF
              doc.save(this.generateReportFileName());
            });
          })
      }
    })
  }


  exportToExcel(data: any[], fileName: string): void {
    const worksheet = XLSX.utils.json_to_sheet(data, {
      header: Object.keys(data[0] || {}),
      skipHeader: false
    });

    // Aplicar estilos a la cabecera y alinear todas las columnas al centro
    const headerRange = XLSX.utils.decode_range(worksheet['!ref']);
    for (let row = headerRange.s.r; row <= headerRange.e.r; row++) {
      for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
        const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
        if (!worksheet[cellAddress]) continue;
        worksheet[cellAddress].s = {
          font: { bold: row === 0, color: { rgb: "000000" } },
          alignment: { horizontal: "center" },
          border: row === 0 ? { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } : {}
        };
      }
    }

    // Ajustar el ancho de las columnas al contenido más largo
    const colWidths = Object.keys(data[0] || {}).map((key, index) => ({ wch: Math.max(...data.map(row => (row[key] ? row[key].toString().length : 0)), key.length) + 2 }));
    worksheet['!cols'] = colWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Marcajes");
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  }

  generateReportFileName(): string {
    const companyPart = `(${this.inputData.companyData.name})`;
    const datePart = `(${this.formatExportNameDate(new Date(this.inputData.day))} UTC)`;
    const userPart = `(${this.inputData.userData.fullName})`;
    const baseText = 'Reporte_Registros_LivesHR'

    return `${baseText}${datePart}${companyPart}${userPart}.pdf`;
  }

  getInvalidRecordTooltip(error: string): string {
    const tooltip = `${error}`

    return tooltip;
  }

}